
/**
 * Sprint Task
 * https://developerx.atlassian.net/browse/CS-5132
 *
 * Date Created : 14 Dec 2021       Created by   : Risman Abdilah
 * Date Updated : 14 Dec 2021       Updated by   : Risman Abdilah
 *
 * Version 1.0.1
 */

import Vue from "vue";
import Component from "vue-class-component";
import { Prop } from "vue-property-decorator";
import { Action, State } from "vuex-class";

import { data2blob } from "@/functions/imagecrop.function";
import { JobFairModel, JobFairPartnerModel } from "@/models/job.model";

import VueImageCropUpload from 'vue-image-crop-upload';
import toast from "@/functions/toast.function";

@Component({
  components: {
    VueImageCropUpload,
  },
})
export default class ModalAddPartner extends Vue {
  /* VUEX */

  /* ACTIONS */
  @Action("actionGetPartnerJobfair", { namespace: "job" })
  public actionGetPartnerJobfair: any;
  @Action("actionAddPartnerJobfair", { namespace: "job" })
  public actionAddPartnerJobfair: any;

  /* STATE */
  @State("locale")
  public locale: string;
  @State("job_fair_partner", { namespace: "job" })
  public job_fair_partner: JobFairPartnerModel;
  @State("array_job_fair_partner", { namespace: "job" })
  public array_job_fair_partner: Array<JobFairPartnerModel>;
  @State("job_fair", { namespace: "job" })
  public job_fair: JobFairModel;

  @Prop({ default: false })
  public isShow: boolean;

  /* INITIALIZATION */
  public showUpload = false;

  /* METHODS */
  public onUploadImage() {
    const elImageCropUpload = this.$refs.fileLogoPartner as any;
    elImageCropUpload.setStep(1);
    this.showUpload = true;
  }

  public cropLogoSuccess(imageDataUrl: any) {
    if (!this.job_fair.id) {
      toast.warning(this.$t('warning_empty_jobfair_add_event'));
      return;
    }

    const elImageCropUpload = this.$refs.fileLogoPartner as any;
    const blobFile = data2blob(imageDataUrl, elImageCropUpload.mime as string);
    const fileName =
      Date.now().toString() + "-partner" + "." + elImageCropUpload.imgFormat;
    this.job_fair_partner.picture = new File([blobFile], fileName);

    this.actionAddPartnerJobfair({
      success: () => {
        this.actionGetPartnerJobfair();
        elImageCropUpload.setStep(1);
        this.showUpload = false;
      },
    });
  }
}
